import { c as _c } from "react/compiler-runtime";
import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, FunctionComponent } from 'react';
import { TimeTrackingConfiguration } from '../../../classes/entities/TimeTrackingConfiguration/timeTrackingConfigurationTypes';
import { TimeTrackingConfigurationListItem } from '../TimeTrackingConfigurationListItem/TimeTrackingConfigurationListItem';
export type TimeTrackingConfigurationListProps = ComponentProps<'div'> & {
  readonly timeTrackingConfigurations: Array<TimeTrackingConfiguration>;
};
export const TimeTrackingConfigurationList: FunctionComponent<TimeTrackingConfigurationListProps> = props => {
  const $ = _c(8);
  let remainingProps;
  let timeTrackingConfigurations;
  if ($[0] !== props) {
    ({
      timeTrackingConfigurations,
      ...remainingProps
    } = props);
    $[0] = props;
    $[1] = remainingProps;
    $[2] = timeTrackingConfigurations;
  } else {
    remainingProps = $[1];
    timeTrackingConfigurations = $[2];
  }
  let t0;
  if ($[3] !== timeTrackingConfigurations) {
    t0 = timeTrackingConfigurations.map(_temp);
    $[3] = timeTrackingConfigurations;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== remainingProps || $[6] !== t0) {
    t1 = <div {...remainingProps}>{t0}</div>;
    $[5] = remainingProps;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
function _temp(config) {
  return <TimeTrackingConfigurationListItem timeTrackingConfiguration={config} key={EntityUtils.getTrackingKey(config)} />;
}